import { PaidSignupScreen } from "@/features/auth/screens/PaidSignupScreen";
import { createFileRoute } from "@tanstack/react-router";

const SignupWithPlan = () => {
    const { plan } = Route.useParams();
    const { canceled, email } = Route.useSearch();

    return <PaidSignupScreen plan={plan} canceled={canceled} email={email} />;
};

export const Route = createFileRoute("/_auth/_public/signup/$plan")({
    component: SignupWithPlan,
    validateSearch: (search: Record<string, unknown>) => {
        return {
            canceled: (search?.canceled as boolean) ?? false,
            email: (search?.email as string) ?? undefined,
        };
    },
});
